import React from 'react';
import {
  Button,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Paragraph,
} from '@axiom/ui';

export type PleaseUseDesktopModalProps = { onClose: () => void };

export const PleaseUseDesktopModal = ({
  onClose,
}: PleaseUseDesktopModalProps) => {
  return (
    <Modal size="confirm" name="PLEASE_USE_DESKTOP_MODAL">
      <ModalHeader
        name="HEADER"
        onClose={() => {
          onClose();
        }}
      >
        Interview Availability
      </ModalHeader>
      <ModalSection>
        <Paragraph>
          To update your availability, please use a desktop or laptop.
        </Paragraph>
      </ModalSection>
      <ModalFooter>
        <Button
          name="CLOSE"
          onClick={() => {
            onClose();
          }}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
